import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { animateScroll } from 'react-scroll';
// import ReactGA from 'react-ga';

class ScrollTo extends React.PureComponent {
  componentDidMount() {
    const { location } = this.props;
    // ReactGA.pageview(location.pathname);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    // ReactGA.pageview(location.pathname);

    if (location !== prevProps.location) {
      if (location.hash !== '') {
        setTimeout(() => {
          const offset = document.getElementById(location.hash.slice(1)).getBoundingClientRect()
            .top;
          animateScroll.scrollMore(offset);
          location.hash = '';
        }, 200);
      } else {
        animateScroll.scrollToTop({
          duration: 500
        });
      }
    }
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

ScrollTo.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};

export default withRouter(connect()(ScrollTo));



// WEBPACK FOOTER //
// ./src/components/Layout/OnRouteScrollTo.js